import { MessageSquare } from 'lucide-react'

/**
 * Анимированный (пульсирующий) бейдж «новый комментарий куратора, который нужно
 * прочитать». Используется на блоках Питание / Показатели / Тренировка.
 */
export function UnreadCommentBadge({ size = 20, title = 'Новый комментарий куратора' }: { size?: number; title?: string }) {
  return (
    <span className="unread-comment-badge" style={{ width: size, height: size }} title={title} aria-label={title}>
      <MessageSquare size={Math.round(size * 0.6)} strokeWidth={2.4} />
    </span>
  )
}
